import { render, staticRenderFns } from "./CategoryType.vue?vue&type=template&id=5627014c&scoped=true"
import script from "./CategoryType.vue?vue&type=script&lang=js"
export * from "./CategoryType.vue?vue&type=script&lang=js"
import style0 from "./CategoryType.vue?vue&type=style&index=0&id=5627014c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627014c",
  null
  
)

export default component.exports